import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Creator } from '~/clientApi/creator.model';
import { routes } from '~/core/router';

import { CountriesDistributionWidget } from './CountryDistributionWidget';

export function ImageWithConnectButton({ creator }: { creator?: Creator }) {
  const router = useRouter();

  const handleClick = useCallback(async () => {
    if (creator?.slug) {
      await router.push(
        {
          pathname: routes.talentProfilePlatformConnections(creator.slug),
          query: { creatorSlug: creator.slug },
        },
        undefined,
        { shallow: true },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creator?.slug]);

  return (
    <CountriesDistributionWidget
      title="Countries distribution"
      description="Audience location estimates are not yet supported for Talent from this region. Invite them to connect to view verified metrics."
      button={{
        children: 'Connect',
        onClick: handleClick,
      }}
    />
  );
}
